/* projects/family-portal/src/app/components/family-portal-layout-page/family-portal-layout-page.component.scss */
/*# sourceMappingURL=family-portal-layout-page.component-NLRNQCVQ.css.map */
